import { TimelineMax, TweenMax } from 'gsap';
import ScrollMagic from 'scrollmagic';
import {
  ScrollMagicPluginIndicator,
  ScrollMagicPluginGsap,
} from 'scrollmagic-plugins';
import * as bodymovin from 'lottie-web';

export const scrollAnimation = () => {
  var animationTarget = document.getElementById('trigger');

  if (!animationTarget) {
    return;
  }

  ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
  ScrollMagicPluginIndicator(ScrollMagic);
  var controller = new ScrollMagic.Controller();

  var animation = bodymovin.loadAnimation({
    container: document.getElementById('lottie'),
    path: '/wp-content/themes/genv/static/img/json/genv_logo.json',
    renderer: 'svg',
    loop: false,
    autoplay: false,
    name: 'Welcome to Awesomeness',
  });

  var tl = new TimelineMax();
  tl.to({ frame: 0 }, 3, {
    frame: 2100,
    onUpdate: function () {
      animation.goToAndStop(Math.round(this.target.frame), true);
    },
    ease: Linear.easeNone,
  });

  var tl1 = new TimelineMax()
    .to('#text1', 3, { y: '-=30vh', opacity: 1, ease: Power2.easeOut })
    .to('#text1', 3, { y: '-=70vh', opacity: 0, ease: Power2.easeIn });

  var tl2 = new TimelineMax()
    .to('#text2', 3, { y: '-=50vh', opacity: 1, ease: Power2.easeOut })
    .to('#text2', 3, { y: '-=50vh', opacity: 0, ease: Power2.easeIn });

  var tl3 = new TimelineMax()
    .to('#text3', 3, { y: '-=50vh', opacity: 1, ease: Power2.easeOut })
    .to('#text3', 3, { y: '-=50vh', opacity: 0, ease: Power2.easeIn });

  var tl4 = new TimelineMax()
    .to('#text4', 3, { y: '-=50vh', opacity: 1, ease: Power2.easeOut })
    .to('#text4', 3, { y: '-=50vh', opacity: 0, ease: Power2.easeIn });

  var tl5 = new TimelineMax()
    .to('#text5', 3, { y: '-=50vh', opacity: 1, ease: Power2.easeOut })
    .to('#text5', 3, { y: '-=50vh', opacity: 0, ease: Power2.easeIn });

  let textDuration = 120;
  let textOffset = 80;
  let textStart = 600;

  new ScrollMagic.Scene({
    triggerElement: '#trigger',
    duration: 1800,
    offset: 325,
  })
    .setTween(tl)
    .setPin('#lottie')
    .addTo(controller);

  new ScrollMagic.Scene({
    triggerElement: '#trigger',
    duration: textDuration,
    offset: textStart + textOffset,
  })
    .setTween(tl1)
    .addTo(controller);

  new ScrollMagic.Scene({
    triggerElement: '#trigger',
    duration: textDuration,
    offset: textStart + textDuration + textOffset,
  })
    .setTween(tl2)
    .addTo(controller);

  new ScrollMagic.Scene({
    triggerElement: '#trigger',
    duration: textDuration,
    offset: textStart + 2 * textDuration + textOffset,
  })
    .setTween(tl3)
    .addTo(controller);

  new ScrollMagic.Scene({
    triggerElement: '#trigger',
    duration: textDuration,
    offset: textStart + 3 * textDuration + textOffset,
  })
    .setTween(tl4)
    .addTo(controller);

  new ScrollMagic.Scene({
    triggerElement: '#trigger',
    duration: textDuration,
    offset: textStart + 4 * textDuration + textOffset,
  })
    .setTween(tl5)
    .addTo(controller);
};
